module.exports = __webpack_public_path__ + "static/media/41-7.61a3b47d.mp3";